import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

const Table = React.forwardRef((props, ref) => {
    const {
        borderlessRow,
        children,
        className,
        hoverable,
        compact,
        oveerflow = true,
        asElement: Component,
        heightAuto = true,
        disableVerticalScroll = false,
        ...rest
    } = props

    const tableClass = classNames(
        Component === 'table' ? 'table-default' : 'table-flex',
        hoverable && 'table-hover',
        compact && 'table-compact',
        borderlessRow && 'borderless-row',
        className
    )

    return (
        <div ref={ref} className={classNames(
            oveerflow && (disableVerticalScroll ? 'overflow-x-auto overflow-y-hidden' : 'overflow-x-auto'),
            !disableVerticalScroll && heightAuto && 'h-5/6',
            disableVerticalScroll && 'h-auto',
            'relative', 
            !heightAuto && !disableVerticalScroll && 'scrollbar-thin'
        )} 
        //  style={{
        //     //msOverflowStyle: 'none',    
        //     //scrollbarWidth: 'none',        
        //     overflowY: 'auto',                
        // }}
        // onScroll={(e) => {
        //     // e.target.style.overflowY = 'auto';
        //     // e.target.style.scrollbarWidth = 'none';
        //     // e.target.style.msOverflowStyle = 'none';
          
        // }}
        style={disableVerticalScroll ? {
            height: 'auto',
            maxHeight: 'none',
            overflowY: 'hidden'
        } : (!heightAuto ? {
            scrollbarWidth: 'thin'
        } : {})}
        >
            <Component className={tableClass} {...rest} ref={ref}>
                {children}
            </Component>
        </div>
    )
})

Table.propTypes = {
    hoverable: PropTypes.bool,
    compact: PropTypes.bool,
    asElement: PropTypes.string,
    borderlessRow: PropTypes.bool,
    disableVerticalScroll: PropTypes.bool,
}

Table.defaultProps = {
    hoverable: true,
    compact: false,
    asElement: 'table',
    borderlessRow: false,
    disableVerticalScroll: false,
}

export default Table
